import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
// import { MdPhone } from "react-icons/md";
import { Container, Row, Col, Box } from "../../../components/ui/wrapper";
import Heading from "../../../components/ui/heading";
import Text from "../../../components/ui/text";
import Anchor from "../../../components/ui/anchor";
import Button from "../../../components/ui/button";
import { SectionWrap, ContactInfoBox } from "./contact-area.style";
import Icon from "../../../components/ui/icon";
import parse from "html-react-parser";
import { Link } from 'gatsby';

const ContactArea = ({
  headingStyle,
  descStyle,
  conactInfoStyles: { iconStyle, titleStyle, phoneAnchorStyle, btnStyle }
}) => {
  const contactQueryData = useStaticQuery(graphql`
    query InfoTechContactQuery {
      sectionData: infotechnoJson(jsonId: { eq: "infotechno-contact-content" }) {
        title
        desc
      }
      sectionBg: file(relativePath: { eq: "images/bg/contact-bg.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, quality: 70, placeholder: BLURRED)
        }
      }
      contactData: site {
        siteMetadata {
          contact {
            email
          }
        }
      }
    }
  `);
  const { title, desc } = contactQueryData.sectionData || {};
  if (!contactQueryData.sectionData) {
    console.warn("ContactArea: sectionData is null");
  }
  const imageData = contactQueryData.sectionBg?.childImageSharp?.gatsbyImageData;
  const { email } = contactQueryData.contactData.siteMetadata.contact;
  // Inline style fallbacks for styled-components hydration issues in dev mode
  const sectionStyle = {
    position: 'relative',
    paddingTop: '120px',
    paddingBottom: '120px',
    backgroundColor: '#f6f2fa'
  };

  return (
    <SectionWrap style={sectionStyle}>
      <GatsbyImage
        image={imageData}
        alt=""
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 0 }}
      />
      <Container style={{ position: "relative", zIndex: 1 }}>
        <Row alignitems="center">
          <Col lg={6}>
            <Box>
              {title && <Heading {...headingStyle}>{parse(title)}</Heading>}
              {desc && <Text {...descStyle}>{parse(desc)}</Text>}
            </Box>
          </Col>
          <Col lg={6}>
            <ContactInfoBox>
              <Icon {...iconStyle} iconName="fal fa-paper-plane" />
              <Heading {...titleStyle}>REACH OUT NOW!</Heading>
              {email && (
                <Heading>
                  <Anchor path={`mailto:${email}`} {...phoneAnchorStyle}>
                    {email}
                  </Anchor>
                </Heading>
              )}
              <Button
                to="/free-consultation"
                as={Link}
                {...btnStyle}
              >
                Start A Conversation
              </Button>
            </ContactInfoBox>
          </Col>
        </Row>
      </Container>
    </SectionWrap>
  );
};

ContactArea.propTypes = {
  headingStyle: PropTypes.object
};

ContactArea.defaultProps = {
  headingStyle: {
    as: "h3",
    position: "relative",
    pl: "34px",
    fontweight: 600,
    lineHeight: 1.4,
    layout: "quote",
    child: {
      color: "primary"
    },
    before: {
      top: "50%",
      width: "4px",
      height: "94%",
      bgColor: "secondary",
      transform: "translateY(-50%)"
    }
  },
  descStyle: {
    mt: "15px",
    fontSize: "18px",
    ml: "34px"
  },
  conactInfoStyles: {
    iconStyle: {
      fontSize: "40px",
      mb: "14px",
      color: "primary"
    },
    titleStyle: {
      as: "h6",
      fontSize: "15px",
      letterspacing: "2px",
      texttransform: "uppercase",
      mb: "10px",
      mt: "10px"
    },
    phoneAnchorStyle: {
      color: "secondary",
      hover: {
        layout: 2,
        color: "secondary"
      }
    },
    btnStyle: {
      mt: "20px",
      skin: "secondary",
      minwidth: "230px",
      hover: {
        bgColor: "primary"
      }
    }
  }
};

export default ContactArea;
